module.exports = __webpack_public_path__ + "static/media/uber-delivery-icon.7409e245.svg";